import * as React from "react";
import { PrimaryButton } from "@graffer-inc/console-design-kit";

import { ResourceFetchError } from "../../../../organisms/common/resource-fetch-error";
import { ApplicationEntity } from "../../../../../application/domain/application/application-entity";
import { ProcedureEntity } from "../../../../../application/domain/procedures/procedure-entity";
import { TenantProcessResultEdit } from "./edit";
import { TenantProcessResultView } from "./view";
import type { ApplicationDetailContextProps } from "../../../../../application/service/smart-apply/application-detail/application-detail-service";
import { InputElementUnion } from "@graffer-inc/form-schema";

const getLabelExamples = (inputElements: InputElementUnion[]) => {
  const etcStr = inputElements.length > 2 ? "などの管理情報" : "";
  return inputElements
    .slice(0, 2)
    .map((e) => `「${e.label.text}」`)
    .join("、")
    .concat(etcStr);
};

export type TenantProcessResultProps = {
  application: ApplicationEntity;
  procedure: ProcedureEntity;
  onUpdate: ApplicationDetailContextProps["onUpdateTenantProcessResult"];
};

export const TenantProcessResultPage: React.FC<TenantProcessResultProps> = ({
  application,
  procedure,
  onUpdate,
}) => {
  const [isEditing, setIsEditing] = React.useState<boolean>(false);
  const inputElements =
    procedure.published?.template.tenantProcessResultSetting?.inputElements;
  return (
    <>
      <div className="columns">
        <div className="column is-8 has-text-left">
          {!inputElements ? (
            <ResourceFetchError
              faIcon="fa-list-alt"
              title="設定されていません。"
              subtitle="公開済みの手続きのため、管理情報は設定できません。"
            />
          ) : (
            <>
              {isEditing ? (
                <TenantProcessResultEdit
                  inputElements={inputElements}
                  document={application.tenantProcessResult?.document}
                  onUpdate={onUpdate}
                  finishEdit={() => setIsEditing(false)}
                />
              ) : (
                <>
                  {application.tenantProcessResult ? (
                    <TenantProcessResultView
                      inputElements={inputElements}
                      document={application.tenantProcessResult.document}
                      editable={application.isWip()}
                      startEdit={() => setIsEditing(true)}
                    />
                  ) : (
                    <ResourceFetchError
                      faIcon="fa-list-alt"
                      title="管理情報が入力できます。"
                      subtitle={
                        <>
                          {!application.isWip() ? (
                            <p>
                              対応ステータスを「処理中」に変更すると、
                              {getLabelExamples(inputElements)}
                              が入力できるようになります。
                            </p>
                          ) : (
                            <>
                              <p className="pb-5">
                                {getLabelExamples(inputElements)}
                                が入力できます。
                              </p>
                              <PrimaryButton
                                text={"入力する"}
                                disabled={!application.isWip()}
                                onClick={() => {
                                  setIsEditing(true);
                                }}
                              />
                            </>
                          )}
                        </>
                      }
                    />
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};
